<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Getting Started'"
      [canGoBack]="true" 
      [customBack]="'/more'"/>
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-alert class="blue-background">
        <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
          <tidy-image
            [src]="'assets/img/goal.svg'"
            class="header-size" />
          <tidy-text [header]="automatedPercentage + ('% Automated' | translate)" />
          <tidy-text
            [actionBody]="'Free Setup Call'"
            (action)="openDemoUrl()" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="'TIDY helps you automate your cleaning and maintenance tasks to save time and money.'" />
        </tidy-row>
      </tidy-alert>
      <div #confettiContainer>
        @for (goal of goals; track goal) {
          <div class="accordion-item">
            <tidy-goal-tasks-card
              [goals]="goals"
              [goal]="goal"
              (updateGoal)="updateGoal($event[0], $event[1])"
              (goToTaskDetails)="goToStepDetails($event)"
              (openVideo)="openVideo(goal)" />
          </div>
        }
        @if (showAdvancedSteps) {
          <div class="accordion-item">
            <div class="accordion-header">
              <div class="accordion-header-content">
                <div class="goal-title-row">
                  <div class="goal-icon-container">
                    <img [src]="'assets/img/advanced-add.svg'" class="advanced-icon" />
                  </div>
                  <tidy-text [header]="'Advanced'" />
                </div>
              </div>
            </div>
            <div class="accordion-content">
              <form [formGroup]="form">
                @for (step of advancedGoals[0]?.user_goal_steps; track step) {
                  <div style="display: flex; align-items: center; gap: 1rem" [ngClass]="{'completed-task': step.state === 'done'}">
                    <div class="content" style="display: flex; align-items: center">
                      <tidy-checkbox
                        (checkedChange)="markAdvancedStepAsDone(step)"
                        class="checkbox-container"
                        [items]="[{value: true, viewValue: ''}]"
                        [initValue]="step.state === 'done'" />
                      <tidy-text
                        [body]="step.description"
                        style="margin-left: 10px" />
                    </div>
                  </div>
                }
                <div style="display: flex; align-items: center; gap: 1rem; margin-top: 5px">
                  <div style="flex: 1">
                    <tidy-input
                      [icon]="'assets/svg/create.svg'"
                      formControlName="task"
                      [form]="form"
                      label="New task"
                      [submitted]="submitted"
                      [errorMessage]="'Please enter a task'" />
                  </div>
                  <div class="field-height-button">
                    <tidy-button
                      [text]="'+ Add'"
                      [smallBody]="true"
                      [action]="boundAddAdvancedStep"
                      class="secondary" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        }
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
